import React from 'react';
import ccfEmptyCopilotStateStyles from './ccf-empty-copilot-state.styles';
import { Box, Typography, useTheme } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { CcfSparklesIcon, CcfSuggestionIcon, useTranslator } from '@nice-ccf/ui-controls';


/**
 * Component displays copilot empty state container
 * @param props - props
 * @returns
 *  @example -
 * ```
 * <CcfEmptyCopilotState />
 * ```
 */
const CcfEmptyCopilotState = () => {
  const [translate] = useTranslator();
  const theme = useTheme();
  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const styles = ccfEmptyCopilotStateStyles(theme);
  const agentFirstName =  loginCredentialsArray[0].charAt(0).toUpperCase() + loginCredentialsArray[0].slice(1).toLowerCase() || 'Admin';

  return (
    <Box sx={styles.emptyStateContainer} data-testid="acp-empty-container">
      <CcfSparklesIcon htmlColor={theme?.palette?.primary?.main} sx={styles.sparklesIcon}/>
      <Box sx={styles.contentContainer}>
        <CcfSuggestionIcon viewBox="-10 -4 24 24" sx={styles.suggestionIcon} />
        <Box sx={styles.textContainer}>
        <Typography sx={styles.title}>{`${translate('greeting')} ${agentFirstName}`}</Typography>
        <Typography sx={styles.description}>{translate('copilotIntroduction')}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CcfEmptyCopilotState;
